const Influencers = {
  followTheSteps: 'Follow the steps',
  InfluencerStep1: 'Have at least 300.000 followers.',
  InfluencerStep2:
    'Send your email and your giveaway URL to our Instagram @instasorteioo through your profile.',
  InfluencerStep3: 'Wait for your draw to be authorized (24 working hours).',
};

export default Influencers;
